import { createContext } from 'react';
import { assign, createMachine } from "xstate";


//models
import { User } from '../models/User';


export const sesionMachine = createMachine({
    id: "sesionDataFetch",
    initial: "idle",
    context: { user: null, rol:"none"} as {user: User | null, rol: string},
    states: {
      idle: {
      on: {
        VERIFYING: { target: "verifying" },
      },
      },
      unauthorized: {
        entry: assign({
        user: () => null,
        rol: () => "none"
        }),
        on: {
            VERIFYING: { target: "verifying"  },
        },
      },
      verifying: {
        on: {
            AUTHORIZED: { target: "authorized"  },
            UNAUTHORIZED: { target: "unauthorized"  },
        },
      },
      authorized: {
        entry: assign({
        // Desestructuramos el evento para obtener los datos
        user: ({ event }) => event.data?.user,
        rol: ({ event }) => event.data?.user?.role_name
      }),
        on: {
            UNAUTHORIZED: { target: "unauthorized"  },
        },
      },
    },
  }, 
);

export const PromiseSesionContext = createContext<any>({});